import React from "react";

import moment from "moment";
import { Field, Formik } from "formik";
import { Tabs, Input, Typography, Row, Col, Select, Radio, Image } from "antd";

import { fallBackImage } from "../../../../utils/fallbackImage";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";

const { TabPane } = Tabs;
const { REACT_APP_SNG_STORAGE_SERVER_URL } = process.env;

export default ({ rowData, disabled }) => {
  const portionNameMappings = (name) => {
    if (name == null || name <= 0) {
      return;
    }
    if (name == 1) {
      return "Basement-I";
    } else if (name == 2) {
      return "Basement-2";
    } else if (name == 3) {
      return "Ground";
    } else if (name == 4) {
      return "1st";
    } else if (name == 5) {
      return "2nd";
    } else if (name == 6) {
      return "3rd";
    } else {
      return Number(name) - 3 + "th";
    }
  };
  return (
    <>
      <Tabs tabPosition="left" className="tab-side">
        {rowData.occupiers.map((occupier, index) => (
          <TabPane tab={occupier.name} key={occupier.id}>
            <Row>
              <Col span={12} className="column-left">
                <Typography className="typography-faded">
                  Self / Rented
                </Typography>
                <Radio.Group disabled={true} value={occupier.is_renter}>
                  <Radio value={true}>Rented</Radio>
                  <Radio value={false}>Self</Radio>
                </Radio.Group>
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name={`occupiers[${index}].name`}
                  labelText="Name"
                  hideErrorMessage={true}
                  className="text-field"
                  disabled={disabled}
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name={`occupiers[${index}].cnic`}
                  labelText="CNIC"
                  hideErrorMessage={true}
                  className="text-field"
                  disabled={disabled}
                  value={rowData?.occupiers[index].cnic===null&&"-"}
                  placeholder={"—"}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name={`occupiers[${index}].email`}
                  labelText="Email"
                  hideErrorMessage={true}
                  className="text-field"
                  disabled={disabled}
                  value={rowData?.occupiers[index].email===null&&"-"}
                  placeholder={"—"}
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name={`occupiers[${index}].phone_number`}
                  labelText="Phone No"
                  hideErrorMessage={true}
                  className="text-field"
                  disabled={disabled}
                  value={rowData?.occupiers[index].phone_number===null&&"-"}
                  placeholder={"—"}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name={`occupiers[${index}].father_name`}
                  labelText="Father/Husband Name"
                  hideErrorMessage={true}
                  className="text-field"
                  disabled={disabled}
                  value={rowData?.occupiers[index].father_name===null&&"-"}
                  placeholder={"—"}
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  labelText="Business Name"
                  name={`occupiers[${index}].business_name`}
                  hideErrorMessage={true}
                  className="text-field"
                  disabled={disabled}
                  value={rowData?.occupiers[index].business_name===null&&"-"}
                  placeholder={"—"}
                />
              </Col>
            </Row>
            <Row>
              <b>Document Proof</b>
            </Row>
            {occupier.documents &&
              occupier.documents.map((image) => {
                return (
                  <div className="image-parser">
                    <Image
                      width={200}
                      height={200}
                      className="image"
                      src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                      fallback={fallBackImage}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        backgroundColor: "#34343438",
                        fontWeight: 600,
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      {moment(image.created_at).format("DD-MM-YYYY hh:mm")}
                    </span>
                  </div>
                );
              })}

            <Row>
              {(!occupier.documents || occupier.documents.length == 0) && (
                <span>No proof attached</span>
              )}
            </Row>
          </TabPane>
        ))}
      </Tabs>
      {rowData.occupiers.length == 0 && <>No property occupiers were added</>}
    </>
  );
};
